import { BASE_API_URL } from "@src/shared/api/api";

export const API = {
  GET_COLD_MATCHING_RESULTS: (params: string) =>
    `${BASE_API_URL}/matching/cold_matching/results?${params}`,
};
